module.exports = __webpack_public_path__ + "static/media/oops.f3aa6dd9.png";